import { LookupDataEnums } from '../../utilities/Constants';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetZoneJurisdictions = () => {
    const { zoneApiClient, zoneGuid } = useZoneContext();

    return useQuery({
        queryKey: ['get-zone-jurisdictions', zoneGuid],
        queryFn: async () => {
            const response = await zoneApiClient.getZoneSpecificLookupData(
                LookupDataEnums.Jurisdictions
            );

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve jurisdictions.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        cacheTime: Infinity,
        staleTime: Infinity,
    });
};
